import { render } from "./AnnouncementsHomeNode.vue?vue&type=template&id=30627b49&ts=true"
import script from "./AnnouncementsHomeNode.vue?vue&type=script&lang=ts"
export * from "./AnnouncementsHomeNode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__